import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";
import recordPhraseUsageClient from "@workspace/cms-phrases/src/client/recorder";
import { useEffect } from "react";
import useSite from "../useSite";
import replaceVariables from "./replaceVariables";

const useTranslation = (
  id: string,
  { values = {}, defaultTo = "" }: TranslateOptions = {},
) => {
  const { siteConfig } = useSite();
  const { translations } = useAppContext();
  const translation = translations[id];
  const alternate = translations[defaultTo];

  useEffect(() => {
    recordPhraseUsageClient(id, translation);
  }, [id, translation]);

  if (!translation && !alternate) {
    return id;
  }

  return replaceVariables(translation || alternate, {
    siteName: siteConfig.name,
    siteDomain: siteConfig.domain,
    ...values,
  });
};

export default useTranslation;
